/**
 * ObjectTextArrayField React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import TextField from '@material-ui/core/TextField';


/**
 * ObjectTextArrayField is an editing component for text array fields of objects
 *
 * @author Jens Gruschel
 */
export class ObjectTextArrayField extends React.Component {

    handleTextArrayChange(event) {
        this.props.onObjectValueChange(this.props.fieldDef.id, event.target.value === "" ? [] : event.target.value.split("\n"));
    };

    render() {

        const { classes, fieldDef } = this.props;

        return <TextField
            id={fieldDef.id}
            label={fieldDef.name}
            value={this.props.value ? this.props.value.join("\n") : ""}
            disabled={this.props.readOnly}
            className={classes.multiline}
            onChange={event => this.handleTextArrayChange(event)}
            margin="normal"
            multiline={true}
            fullWidth={true}
            type="text"
            helperText={this.props.fieldDef.note}
            variant="outlined"
            rows={5}
            rowsMax={10}
        />;
    }
}

ObjectTextArrayField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const styles = {
    multiline: {
        marginTop: 16
    }
};

export default withStyles(styles)(ObjectTextArrayField);